import React from 'react';
import { SkipLink as SkipLinkBronson } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';

export const SkipLink: React.FC = () => {
    const { t } = useTranslation('translation');
    return <SkipLinkBronson href="#maincontent" label={t('skip-link')} />;
};
